"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Location = _interopRequireDefault(require("./Location"));

var _IllegalArgumentException = _interopRequireDefault(require("../../../../java/lang/IllegalArgumentException"));

var _Dimension = _interopRequireDefault(require("./Dimension"));

var _Cloneable = _interopRequireDefault(require("../../../../java/lang/Cloneable"));

var _StringBuilder = _interopRequireDefault(require("../../../../java/lang/StringBuilder"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var IntersectionMatrix =
/*#__PURE__*/
function () {
  function IntersectionMatrix() {
    _classCallCheck(this, IntersectionMatrix);

    IntersectionMatrix.constructor_.apply(this, arguments);
  }

  _createClass(IntersectionMatrix, [{
    key: "isIntersects",
    value: function isIntersects() {
      return !this.isDisjoint();
    }
  }, {
    key: "isCovers",
    value: function isCovers() {
      var hasPointInCommon = IntersectionMatrix.isTrue(this._matrix[_Location.default.INTERIOR][_Location.default.INTERIOR]) || IntersectionMatrix.isTrue(this._matrix[_Location.default.INTERIOR][_Location.default.BOUNDARY]) || IntersectionMatrix.isTrue(this._matrix[_Location.default.BOUNDARY][_Location.default.INTERIOR]) || IntersectionMatrix.isTrue(this._matrix[_Location.default.BOUNDARY][_Location.default.BOUNDARY]);
      return hasPointInCommon && this._matrix[_Location.default.EXTERIOR][_Location.default.INTERIOR] === _Dimension.default.FALSE && this._matrix[_Location.default.EXTERIOR][_Location.default.BOUNDARY] === _Dimension.default.FALSE;
    }
  }, {
    key: "isCoveredBy",
    value: function isCoveredBy() {
      var hasPointInCommon = IntersectionMatrix.isTrue(this._matrix[_Location.default.INTERIOR][_Location.default.INTERIOR]) || IntersectionMatrix.isTrue(this._matrix[_Location.default.INTERIOR][_Location.default.BOUNDARY]) || IntersectionMatrix.isTrue(this._matrix[_Location.default.BOUNDARY][_Location.default.INTERIOR]) || IntersectionMatrix.isTrue(this._matrix[_Location.default.BOUNDARY][_Location.default.BOUNDARY]);
      return hasPointInCommon && this._matrix[_Location.default.INTERIOR][_Location.default.EXTERIOR] === _Dimension.default.FALSE && this._matrix[_Location.default.BOUNDARY][_Location.default.EXTERIOR] === _Dimension.default.FALSE;
    }
  }, {
    key: "set",
    value: function set() {
      if (arguments.length === 1) {
        var dimensionSymbols = arguments[0];

        for (var i = 0; i < dimensionSymbols.length; i++) {
          var row = Math.trunc(i / 3);
          var col = i % 3;
          this._matrix[row][col] = _Dimension.default.toDimensionValue(dimensionSymbols.charAt(i));
        }
      } else if (arguments.length === 3) {
        var _row = arguments[0],
            column = arguments[1],
            dimensionValue = arguments[2];
        this._matrix[_row][column] = dimensionValue;
      }
    }
  }, {
    key: "isContains",
    value: function isContains() {
      return IntersectionMatrix.isTrue(this._matrix[_Location.default.INTERIOR][_Location.default.INTERIOR]) && this._matrix[_Location.default.EXTERIOR][_Location.default.INTERIOR] === _Dimension.default.FALSE && this._matrix[_Location.default.EXTERIOR][_Location.default.BOUNDARY] === _Dimension.default.FALSE;
    }
  }, {
    key: "setAtLeast",
    value: function setAtLeast() {
      if (arguments.length === 1) {
        var minimumDimensionSymbols = arguments[0];

        for (var i = 0; i < minimumDimensionSymbols.length; i++) {
          var row = Math.trunc(i / 3);
          var col = i % 3;
          this.setAtLeast(row, col, _Dimension.default.toDimensionValue(minimumDimensionSymbols.charAt(i)));
        }
      } else if (arguments.length === 3) {
        var _row2 = arguments[0],
            column = arguments[1],
            minimumDimensionValue = arguments[2];

        if (this._matrix[_row2][column] < minimumDimensionValue) {
          this._matrix[_row2][column] = minimumDimensionValue;
        }
      }
    }
  }, {
    key: "setAtLeastIfValid",
    value: function setAtLeastIfValid(row, column, minimumDimensionValue) {
      if (row >= 0 && column >= 0) {
        this.setAtLeast(row, column, minimumDimensionValue);
      }
    }
  }, {
    key: "isWithin",
    value: function isWithin() {
      return IntersectionMatrix.isTrue(this._matrix[_Location.default.INTERIOR][_Location.default.INTERIOR]) && this._matrix[_Location.default.INTERIOR][_Location.default.EXTERIOR] === _Dimension.default.FALSE && this._matrix[_Location.default.BOUNDARY][_Location.default.EXTERIOR] === _Dimension.default.FALSE;
    }
  }, {
    key: "isTouches",
    value: function isTouches(dimensionOfGeometryA, dimensionOfGeometryB) {
      if (dimensionOfGeometryA > dimensionOfGeometryB) {
        return this.isTouches(dimensionOfGeometryB, dimensionOfGeometryA);
      }

      if (dimensionOfGeometryA === _Dimension.default.A && dimensionOfGeometryB === _Dimension.default.A || dimensionOfGeometryA === _Dimension.default.L && dimensionOfGeometryB === _Dimension.default.L || dimensionOfGeometryA === _Dimension.default.L && dimensionOfGeometryB === _Dimension.default.A || dimensionOfGeometryA === _Dimension.default.P && dimensionOfGeometryB === _Dimension.default.A || dimensionOfGeometryA === _Dimension.default.P && dimensionOfGeometryB === _Dimension.default.L) {
        return this._matrix[_Location.default.INTERIOR][_Location.default.INTERIOR] === _Dimension.default.FALSE && (IntersectionMatrix.isTrue(this._matrix[_Location.default.INTERIOR][_Location.default.BOUNDARY]) || IntersectionMatrix.isTrue(this._matrix[_Location.default.BOUNDARY][_Location.default.INTERIOR]) || IntersectionMatrix.isTrue(this._matrix[_Location.default.BOUNDARY][_Location.default.BOUNDARY]));
      }

      return false;
    }
  }, {
    key: "isOverlaps",
    value: function isOverlaps(dimensionOfGeometryA, dimensionOfGeometryB) {
      if (dimensionOfGeometryA === _Dimension.default.P && dimensionOfGeometryB === _Dimension.default.P || dimensionOfGeometryA === _Dimension.default.A && dimensionOfGeometryB === _Dimension.default.A) {
        return IntersectionMatrix.isTrue(this._matrix[_Location.default.INTERIOR][_Location.default.INTERIOR]) && IntersectionMatrix.isTrue(this._matrix[_Location.default.INTERIOR][_Location.default.EXTERIOR]) && IntersectionMatrix.isTrue(this._matrix[_Location.default.EXTERIOR][_Location.default.INTERIOR]);
      }

      if (dimensionOfGeometryA === _Dimension.default.L && dimensionOfGeometryB === _Dimension.default.L) {
        return this._matrix[_Location.default.INTERIOR][_Location.default.INTERIOR] === 1 && IntersectionMatrix.isTrue(this._matrix[_Location.default.INTERIOR][_Location.default.EXTERIOR]) && IntersectionMatrix.isTrue(this._matrix[_Location.default.EXTERIOR][_Location.default.INTERIOR]);
      }

      return false;
    }
  }, {
    key: "isEquals",
    value: function isEquals(dimensionOfGeometryA, dimensionOfGeometryB) {
      if (dimensionOfGeometryA !== dimensionOfGeometryB) {
        return false;
      }

      return IntersectionMatrix.isTrue(this._matrix[_Location.default.INTERIOR][_Location.default.INTERIOR]) && this._matrix[_Location.default.INTERIOR][_Location.default.EXTERIOR] === _Dimension.default.FALSE && this._matrix[_Location.default.BOUNDARY][_Location.default.EXTERIOR] === _Dimension.default.FALSE && this._matrix[_Location.default.EXTERIOR][_Location.default.INTERIOR] === _Dimension.default.FALSE && this._matrix[_Location.default.EXTERIOR][_Location.default.BOUNDARY] === _Dimension.default.FALSE;
    }
  }, {
    key: "toString",
    value: function toString() {
      var builder = new _StringBuilder.default("123456789");

      for (var ai = 0; ai < 3; ai++) {
        for (var bi = 0; bi < 3; bi++) {
          builder.setCharAt(3 * ai + bi, _Dimension.default.toDimensionSymbol(this._matrix[ai][bi]));
        }
      }

      return builder.toString();
    }
  }, {
    key: "setAll",
    value: function setAll(dimensionValue) {
      for (var ai = 0; ai < 3; ai++) {
        for (var bi = 0; bi < 3; bi++) {
          this._matrix[ai][bi] = dimensionValue;
        }
      }
    }
  }, {
    key: "get",
    value: function get(row, column) {
      return this._matrix[row][column];
    }
  }, {
    key: "transpose",
    value: function transpose() {
      var temp = this._matrix[1][0];
      this._matrix[1][0] = this._matrix[0][1];
      this._matrix[0][1] = temp;
      temp = this._matrix[2][0];
      this._matrix[2][0] = this._matrix[0][2];
      this._matrix[0][2] = temp;
      temp = this._matrix[2][1];
      this._matrix[2][1] = this._matrix[1][2];
      this._matrix[1][2] = temp;
      return this;
    }
  }, {
    key: "matches",
    value: function matches(requiredDimensionSymbols) {
      if (requiredDimensionSymbols.length !== 9) {
        throw new _IllegalArgumentException.default("Should be length 9: " + requiredDimensionSymbols);
      }

      for (var ai = 0; ai < 3; ai++) {
        for (var bi = 0; bi < 3; bi++) {
          if (!IntersectionMatrix.matches(this._matrix[ai][bi], requiredDimensionSymbols.charAt(3 * ai + bi))) {
            return false;
          }
        }
      }

      return true;
    }
  }, {
    key: "add",
    value: function add(im) {
      for (var i = 0; i < 3; i++) {
        for (var j = 0; j < 3; j++) {
          this.setAtLeast(i, j, im.get(i, j));
        }
      }
    }
  }, {
    key: "isDisjoint",
    value: function isDisjoint() {
      return this._matrix[_Location.default.INTERIOR][_Location.default.INTERIOR] === _Dimension.default.FALSE && this._matrix[_Location.default.INTERIOR][_Location.default.BOUNDARY] === _Dimension.default.FALSE && this._matrix[_Location.default.BOUNDARY][_Location.default.INTERIOR] === _Dimension.default.FALSE && this._matrix[_Location.default.BOUNDARY][_Location.default.BOUNDARY] === _Dimension.default.FALSE;
    }
  }, {
    key: "isCrosses",
    value: function isCrosses(dimensionOfGeometryA, dimensionOfGeometryB) {
      if (dimensionOfGeometryA === _Dimension.default.P && dimensionOfGeometryB === _Dimension.default.L || dimensionOfGeometryA === _Dimension.default.P && dimensionOfGeometryB === _Dimension.default.A || dimensionOfGeometryA === _Dimension.default.L && dimensionOfGeometryB === _Dimension.default.A) {
        return IntersectionMatrix.isTrue(this._matrix[_Location.default.INTERIOR][_Location.default.INTERIOR]) && IntersectionMatrix.isTrue(this._matrix[_Location.default.INTERIOR][_Location.default.EXTERIOR]);
      }

      if (dimensionOfGeometryA === _Dimension.default.L && dimensionOfGeometryB === _Dimension.default.P || dimensionOfGeometryA === _Dimension.default.A && dimensionOfGeometryB === _Dimension.default.P || dimensionOfGeometryA === _Dimension.default.A && dimensionOfGeometryB === _Dimension.default.L) {
        return IntersectionMatrix.isTrue(this._matrix[_Location.default.INTERIOR][_Location.default.INTERIOR]) && IntersectionMatrix.isTrue(this._matrix[_Location.default.EXTERIOR][_Location.default.INTERIOR]);
      }

      if (dimensionOfGeometryA === _Dimension.default.L && dimensionOfGeometryB === _Dimension.default.L) {
        return this._matrix[_Location.default.INTERIOR][_Location.default.INTERIOR] === 0;
      }

      return false;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return IntersectionMatrix;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [_Cloneable.default];
    }
  }], [{
    key: "matches",
    value: function matches() {
      if (Number.isInteger(arguments[0]) && typeof arguments[1] === "string") {
        var actualDimensionValue = arguments[0],
            requiredDimensionSymbol = arguments[1];

        if (requiredDimensionSymbol === _Dimension.default.SYM_DONTCARE) {
          return true;
        }

        if (requiredDimensionSymbol === _Dimension.default.SYM_TRUE && (actualDimensionValue >= 0 || actualDimensionValue === _Dimension.default.TRUE)) {
          return true;
        }

        if (requiredDimensionSymbol === _Dimension.default.SYM_FALSE && actualDimensionValue === _Dimension.default.FALSE) {
          return true;
        }

        if (requiredDimensionSymbol === _Dimension.default.SYM_P && actualDimensionValue === _Dimension.default.P) {
          return true;
        }

        if (requiredDimensionSymbol === _Dimension.default.SYM_L && actualDimensionValue === _Dimension.default.L) {
          return true;
        }

        if (requiredDimensionSymbol === _Dimension.default.SYM_A && actualDimensionValue === _Dimension.default.A) {
          return true;
        }

        return false;
      } else if (typeof arguments[0] === "string" && typeof arguments[1] === "string") {
        var actualDimensionSymbols = arguments[0],
            requiredDimensionSymbols = arguments[1];
        var m = new IntersectionMatrix(actualDimensionSymbols);
        return m.matches(requiredDimensionSymbols);
      }
    }
  }, {
    key: "isTrue",
    value: function isTrue(actualDimensionValue) {
      if (actualDimensionValue >= 0 || actualDimensionValue === _Dimension.default.TRUE) {
        return true;
      }

      return false;
    }
  }]);

  return IntersectionMatrix;
}();

exports.default = IntersectionMatrix;

IntersectionMatrix.constructor_ = function () {
  this._matrix = null;

  if (arguments.length === 0) {
    this._matrix = Array(3).fill().map(function () {
      return Array(3);
    });
    this.setAll(_Dimension.default.FALSE);
  } else if (arguments.length === 1) {
    if (typeof arguments[0] === "string") {
      var elements = arguments[0];
      IntersectionMatrix.constructor_.call(this);
      this.set(elements);
    } else if (arguments[0] instanceof IntersectionMatrix) {
      var other = arguments[0];
      IntersectionMatrix.constructor_.call(this);
      this._matrix[_Location.default.INTERIOR][_Location.default.INTERIOR] = other._matrix[_Location.default.INTERIOR][_Location.default.INTERIOR];
      this._matrix[_Location.default.INTERIOR][_Location.default.BOUNDARY] = other._matrix[_Location.default.INTERIOR][_Location.default.BOUNDARY];
      this._matrix[_Location.default.INTERIOR][_Location.default.EXTERIOR] = other._matrix[_Location.default.INTERIOR][_Location.default.EXTERIOR];
      this._matrix[_Location.default.BOUNDARY][_Location.default.INTERIOR] = other._matrix[_Location.default.BOUNDARY][_Location.default.INTERIOR];
      this._matrix[_Location.default.BOUNDARY][_Location.default.BOUNDARY] = other._matrix[_Location.default.BOUNDARY][_Location.default.BOUNDARY];
      this._matrix[_Location.default.BOUNDARY][_Location.default.EXTERIOR] = other._matrix[_Location.default.BOUNDARY][_Location.default.EXTERIOR];
      this._matrix[_Location.default.EXTERIOR][_Location.default.INTERIOR] = other._matrix[_Location.default.EXTERIOR][_Location.default.INTERIOR];
      this._matrix[_Location.default.EXTERIOR][_Location.default.BOUNDARY] = other._matrix[_Location.default.EXTERIOR][_Location.default.BOUNDARY];
      this._matrix[_Location.default.EXTERIOR][_Location.default.EXTERIOR] = other._matrix[_Location.default.EXTERIOR][_Location.default.EXTERIOR];
    }
  }
};